import { render } from "./AlterNavBar.vue?vue&type=template&id=0245ca39"
import script from "./AlterNavBar.vue?vue&type=script&lang=js"
export * from "./AlterNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__